export const createCompanyApiConfig = company => ({
    url: '/api/clients/create',
    method: 'POST',
    data: company,
});
